export default __webpack_public_path__ + "static/media/insta.abcfa879.svg";